module.exports = __webpack_public_path__ + "img/ic_download.997fcebd.svg";